import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { Hidden, Box, Text, Inline, IconChevron } from "braid-design-system";
import omit from "lodash/omit.js";
import { generalLink } from "../EmployerFooter.css.mjs";
const PartnersLink = ({
  href,
  onClick,
  linkRenderer: LinkRenderer,
  partnersChevronDirection,
  name,
  ...restProps
}) => /* @__PURE__ */ jsx(Hidden, { below: "tablet", children: /* @__PURE__ */ jsx(
  Box,
  {
    display: ["block", "inline"],
    paddingTop: ["small", "none"],
    paddingBottom: ["medium", "xsmall"],
    children: /* @__PURE__ */ jsx(Text, { size: "small", weight: "medium", children: /* @__PURE__ */ jsx(
      LinkRenderer,
      {
        href,
        className: generalLink,
        onClick,
        ...omit(restProps, ["specificSite"]),
        children: /* @__PURE__ */ jsxs(Inline, { space: "xsmall", children: [
          /* @__PURE__ */ jsx(Fragment, { children: name }),
          /* @__PURE__ */ jsx(IconChevron, { direction: partnersChevronDirection })
        ] })
      }
    ) })
  }
) });
export {
  PartnersLink
};
